/** 设备相关接口 */
import request from '@/utils/util.request';

/**
 * @desc (home) 发送设备命令
 * @param {string} action 指令 "imhere"
 */
export const device_command = (data) => {
	return request({
		url: '/home/devicecmd',
		data,
	});
};

/*
 *  (update) 升级命令页面
 */
export const update_load_data = (data) => {
	return request({
		url: '/update/loaddata',
		data,
	});
};

/*
 *  (update) 升级命令
 */
export const update_submit = (data) => {
	return request({
		url: '/update/update',
		data,
	});
};

/*
 *  (screen) 截屏命令
 */
export const screen_capture = (data) => {
	return request({
		url: '/screen/capture',
		data,
		loading: false,
	});
};

/*
 *  (screen) 截屏状态
 */
export const screen_status = (data) => {
	return request({
		url: '/screen/status',
		data,
	});
};
